<template>
  <form novalidate @submit.prevent="validateUser" class="loginContainer">
    <div style="width: 90%; margin: 0 auto;">
      <div class="row">
        <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6 col-sm-offset-1 col-md-offset-2 col-lg-offset-3">
          <div class="row">
            <div class="col-xs-12 center-xs mar-b30">
              <img src="../assets/logo.png">
            </div>
          </div>
          <div class="row">
            <div class="col-xs-8 col-lg-6 col-xs-offset-2 col-lg-offset-3">
              <div class="form-group">
                <label for>Email Address</label>
                <input type="email" v-model="form.emailAddress" required placeholder="email address">
              </div>
              <div class="form-group">
                <label for>Password</label>
                <input type="password" v-model="form.password" required placeholder="email address">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 center-xs">
              <button type="submit" class="btn btn-md" :disabled="sending" @click="login">
                <span>Login</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "../utils/axios";
import auth from "../utils/auth";

export default {
  name: "Login",
  mixins: [],
  data() {
    return {
      form: {
        emailAddress: null,
        password: null
      },
      sending: false,
      badpassword: false
    };
  },
  created: function() {
    if (auth.isAuthenticated()) {
      this.$router.push("/wallboards");
    }
  },
  methods: {
    login() {
      this.sending = true;
      axios.post("auth/login", this.form).then(response => {
        this.sending = false;
        if (response.data && response.data.token) {
          this.badpassword = false;
          localStorage.setItem("token", response.data.token);
          auth.user.authenticated = true;
          this.$router.push("/wallboards");
        } else {
          this.badpassword = true;
          localStorage.removeItem("token");
          auth.user.authenticated = false;
        }
      });
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (fieldName == "password" && this.badpassword) return "invalid";
      if (field) {
        return {
          invalid: field.$invalid && field.$dirty
        };
      }
    },
    validateUser() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.login();
      }
    }
  }
};
</script>

<style>
.loginContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
